export function buildImageFormData(baseFields, form, imageFile, fieldName = 'image') {
  if (!imageFile) {
    return baseFields
  }

  const fd = new FormData()

  Object.entries(baseFields).forEach(([key, value]) => {
    if (value == null) return
    if (typeof value === 'boolean') {
      fd.append(key, value ? '1' : '0')
    } else if (typeof value === 'object') {
      fd.append(key, JSON.stringify(value))
    } else {
      fd.append(key, String(value))
    }
  })

  fd.append(fieldName, imageFile)

  return fd
}
